import React, { useEffect, useState } from 'react';
import { getDocs, collection, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { auth, db } from './firebase-config';
import './PreviousComments.css'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';



function PreviousComments() {
    let totalScore = 0;
    let commentNumber = 0;

    const [postList, setPostList] = useState([]);
    const commentCollectionRef = collection(db, "betrayal_comments_2");

    // const deletePost = async (id) => {
    //     const postDoc = doc(db, 'betrayal_comments_2', id)
    //     await deleteDoc(postDoc)
    //     window.location.reload()
    // }

    useEffect(() => {
        const getPosts = async () => {
            const data = await getDocs(commentCollectionRef);
            setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };

        getPosts();
    }, []);

    return (
        <div className="PrevComments">
            {postList.map((post) => {
                totalScore += post.postRating;
                commentNumber++;
            })}

            <div className="container bg-15">
                <div className="row bg-16">
                    <div className="communityScore">

                        <h1>
                            <div className='hexagon'>
                                 {Math.round(totalScore = totalScore / commentNumber)}
                                </div>
                               </h1>
                        <h1>Number of comments: {commentNumber}</h1>
                    </div>
                    {postList.map((post) => {
                        totalScore += post.postRating;
                        return (
                            <div className='container post'>
                                <div className="row postHeader">
                                    <div className="col-8 title">
                                        <h1>{post.title}</h1>
                                    </div>
                                    {/* Come back to debug the delete post button */}
                                    {/* {localStorage.isAuth && post.author.id === auth.currentUser.uid &&
<div className='col-2 deletePost'>
<button onClick={() => { deletePost(post.id)}}><DeleteForeverIcon/></button>
</div>} */}

                                    <div className="col-2 title">
                                        <h1>{post.postRating}</h1>
                                    </div>
                                </div>
                                <div className="row postAuthor">
                                    <div className='container linebreak'></div>
                                    <h3>{post.author.name}</h3>
                                </div>
                                <div className="postTextContainer">
                                    {post.postComment}
                                </div>
                                {/* <div className="row">
            {localStorage.isAuth && post.author.id === auth.currentUser.uid &&
                <div className='deletePost'>
                    <div onClick={() => { deletePost(post.id) }}><DeleteForeverIcon /></div>
                </div>}

        </div> */}
                            </div>);
                    })}
                </div>
            </div>


        </div>
    )
}

export default PreviousComments
